import { getCookie, removeCookie, setCookie } from '@guardian/libs';
const HIDE_SUPPORT_MESSAGING_COOKIE = 'gu_hide_support_messaging';
export const getHideSupportMessagingCookie = () => getCookie({ name: HIDE_SUPPORT_MESSAGING_COOKIE });
export const setHideSupportMessagingCookie = (value) => {
    setCookie({
        name: HIDE_SUPPORT_MESSAGING_COOKIE,
        value: String(value),
    });
};
export const removeHideSupportMessagingCookie = () => removeCookie({ name: HIDE_SUPPORT_MESSAGING_COOKIE });
